import * as React from 'react';

function SvgCreateProperty(props) {
  return (
    <svg
      width={134}
      height={117}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path id="create-property_svg__a" d="M0 0h160v160H0z" />
      </defs>
      <g transform="translate(-9 -23)" fill="none" fillRule="evenodd">
        <mask id="create-property_svg__b" fill="#fff">
          <use xlinkHref="#create-property_svg__a" />
        </mask>
        <g mask="url(#create-property_svg__b)">
          <path
            d="M27.649 111.691c7.986 0 14.46-7.063 14.46-15.775S35.635 73.13 27.65 73.13c-7.987 0-14.46 14.074-14.46 22.786 0 8.712 6.473 15.775 14.46 15.775z"
            fill="#8BD0C9"
          />
          <path
            d="M27.649 86.626c.532 0 .964.589.964 1.315v43.645c0 .725-.432 1.314-.964 1.314-.533 0-.964-.589-.964-1.314v-35.83l-4.37-3.613c-.463-.384-.59-1.163-.283-1.741.308-.578.933-.736 1.396-.353l3.257 2.693v-4.801c0-.726.431-1.315.964-1.315z"
            fill="#90B6B0"
            fillRule="nonzero"
          />
          <path
            d="M55.606 133.864c-3.59-13.497-8.676-20.245-15.259-20.245-9.874 0-6.324 12.392-10.57 13.428-4.245 1.035-4.838-8.252-10.645-8.252-5.807 0-9.8 7.602-9.8 15.069h46.274z"
            fill="#8BD0C9"
          />
          <path fill="#D1CCB7" d="M57 89l-29 17.347v6.194h3.108v13.997H28V139h29z" />
          <path fillOpacity={0.461} fill="#FFF" d="M35 111h16v16H35z" />
          <path fill="#E6E3D8" d="M28 112.5h3.1v14.1H28zm108.8.5h3.2v14.1h-3.2z" />
          <path fill="#63656A" d="M54 84v6.892L28 106v-5.716z" />
          <path fill="#D1CCB7" d="M110 91l30 16.654v5.946h-3.214v13.437H140V139h-30z" />
          <path fillOpacity={0.461} fill="#FFF" d="M132 113h-16v15h16z" />
          <path fill="#63656A" d="M113 87v6.58L140 108v-5.456z" />
          <g>
            <path d="M79.967 25.892L51.165 48.675v90.973h58.806V48.675z" fill="#FFF" />
            <g transform="translate(66.103 105.681)">
              <path
                d="M25.948 31.912H0V12.41C0 5.556 5.809 0 12.974 0s12.974 5.556 12.974 12.41v19.502z"
                fill="#FCCD00"
              />
              <ellipse fill="#4C4C4C" cx={20.182} cy={18.857} rx={1.802} ry={1.813} />
            </g>
            <path
              d="M80.405 23l32.549 26.389v9.875L80.39 33.054 48.084 58.609V48.567L80.405 23z"
              fill="#63656A"
              fillRule="nonzero"
            />
            <path
              d="M78.716 63.615v5.501h-10.09v-5.5h10.09zm12.375 0v5.501H81.6v-5.5h9.492zm-12.375-8.703v5.802h-10.09v-5.802h10.09zm12.376 0v5.802h-9.493v-5.802h9.493zM78.716 88.274v5.501h-10.09v-5.5h10.09zm12.375 0v5.501H81.6v-5.5h9.492zm-12.375-8.703v5.802h-10.09v-5.802h10.09zm12.376 0v5.802h-9.493v-5.802h9.493z"
              fill="#FCCD00"
            />
          </g>
          <g transform="translate(119 36)">
            <path
              d="M24 12c0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12C0 5.373 5.373 0 12 0c6.628 0 12 5.373 12 12"
              fill="#F9A600"
            />
            <rect fill="#FFF" x={6} y={11} width={12} height={2} rx={1} />
            <rect fill="#FFF" x={11.143} y={6} width={2} height={12} rx={1} />
          </g>
          <g transform="rotate(-28 203.246 -111.017)">
            <rect fill="#63656A" x={23.769} y={47.923} width={4.923} height={25.077} rx={2.462} />
            <g transform="translate(.91 .308)">
              <circle fill="#FFF" cx={24.09} cy={26.692} r={19.692} />
              <path
                fill="#EBE9E5"
                d="M41.587 43.416L1.745 22.254l1.667-3.136 38.077 20.221-1.668 3.138M37.819 50.504L1.504 31.23l1.663-3.13 31.016 16.46-1.662 3.127M7.955 43.764l1.672-3.145 9.913 5.258-1.672 3.147z"
              />
              <path
                d="M24.09 5.692c3.684 0 7.146.949 10.156 2.615a13.339 13.339 0 01-1.476 7.867c-3.474 6.533-11.586 9.013-18.12 5.54a13.362 13.362 0 01-6.682-8.48c3.852-4.61 9.645-7.542 16.122-7.542z"
                fill="#38B2A6"
              />
              <path
                d="M15.77 5.874l7.802-1.961a.69.69 0 01.84.447l1.36 3.75.224-.42c.082-.155.268-.219.412-.142l.723.384c.144.077.195.266.113.42l-.83 1.56.735 2.012a.82.82 0 01-.437 1.011.699.699 0 01-.951-.397l-.042-.113-2.913 5.48c-.127.238-.416.337-.639.219l-3.009-1.6 2.697-5.072-2.706-1.439-2.697 5.072-3.01-1.6c-.222-.119-.301-.414-.175-.652l2.914-5.48-.116.03a.7.7 0 01-.51-.056.748.748 0 01-.373-.504c-.072-.434.198-.85.588-.949"
                fill="#FFF"
              />
              <path
                d="M24.09 2.692c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm0 4.308C13.214 7 4.398 15.817 4.398 26.692c0 10.876 8.816 19.693 19.692 19.693s19.692-8.817 19.692-19.693C43.782 15.817 34.966 7 24.09 7z"
                fill="#63656A"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgCreateProperty;
